import { usePosts } from '@uefacom-newdev/liveblog-integration-react';
import { PkButton } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import { useTranslateFn } from '@shared/Translate';

import * as classes from './styles.module.scss';

const ShowNewPosts = () => {
  const t = useTranslateFn();
  const { newPosts, showAddedPosts } = usePosts();

  return (
    <div className={clsx('pk-d--flex', 'pk-justify-content--center', 'pk-w--100', !newPosts?.length && 'pk-d--none')}>
      <PkButton width='auto' className={classes.lbNewposts} onPkClick={showAddedPosts}>
        {newPosts.length} {t(newPosts.length > 1 ? 'lb-new-posts' : 'lb-new-post')}
      </PkButton>
    </div>
  );
};

export default memo(ShowNewPosts);
